import { SET_IS_INITIAL, SET_IS_NOT_INITIAL } from "../action_types";
import store from "../store";

const setIsInitial = () => ({
    type: SET_IS_INITIAL,
});

const setIsNotInitial = () => ({
    type: SET_IS_NOT_INITIAL,
});

export const boundSetIsInitial = () => store.dispatch(setIsInitial());
export const boundSetIsNotInitital = () => store.dispatch(setIsNotInitial());